import { api } from "@/config/api";
import * as Sentry from "@sentry/react-native";
import type { AxiosError } from "axios";
import { CheckoutFailReason, PromoFailReason, RatePassphraseFailReason } from "ipctg-inflow-types/InFlowEnums";
import type {
  ParkCheckoutPOSTErrorResponse,
  ParkCheckoutPOSTRequest,
  ParkCheckoutPOSTSuccessResponse,
  ParkPromoPOSTErrorResponse,
  ParkPromoPOSTRequest,
  ParkPromoPOSTSuccessResponse,
  ParkRatePassphrasePOSTErrorResponse,
  ParkRatePassphrasePOSTRequest,
  ParkRatePassphrasePOSTSuccessResponse,
} from "ipctg-inflow-types/InFlowParkAPI";
import { Platform } from "react-native";

export const fetchCheckoutData = async (requestData: ParkCheckoutPOSTRequest): Promise<ParkCheckoutPOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkCheckoutPOSTSuccessResponse>("/checkout", requestData);
    return response.data;
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        data: requestData,
        localStorage: Platform.OS === "web" ? window.localStorage : null,
      },
    });
    const axiosError = error as AxiosError<ParkCheckoutPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: CheckoutFailReason };
  }
};

export const checkRatePassphrase = async (requestData: ParkRatePassphrasePOSTRequest): Promise<ParkRatePassphrasePOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkRatePassphrasePOSTSuccessResponse>("/rate-passphrase", requestData);
    return response.data;
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        data: requestData,
        localStorage: Platform.OS === "web" ? window.localStorage : null,
      },
    });
    const axiosError = error as AxiosError<ParkRatePassphrasePOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: RatePassphraseFailReason };
  }
};

export const applyPromoCode = async (requestData: ParkPromoPOSTRequest): Promise<ParkPromoPOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkPromoPOSTSuccessResponse>("/promo", requestData);
    return response.data;
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        data: requestData,
        localStorage: Platform.OS === "web" ? window.localStorage : null,
      },
    });
    const axiosError = error as AxiosError<ParkPromoPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: PromoFailReason };
  }
};
